import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AppContextProp {
  streakUpdated: boolean;
  setStreakUpdated: (streakUpdated: boolean) => void;
}

const AppContext = createContext<AppContextProp | undefined>(undefined);

export const AppContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [streakUpdated, setStreakUpdated] = useState(false);

  return (
    <AppContext.Provider value={{ streakUpdated, setStreakUpdated }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = (): AppContextProp => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within a AppContextProvider');
  }
  return context;
};
